export interface IOptimizedImage {
  id: number;
  folder: string;
  original_url: string;
  optimized_url: string;
  medium_url: string;
  small_url: string;
}

export const OptimizedImageUrlFields: [
  'original_url',
  'medium_url',
  'optimized_url',
  'small_url',
] = ['original_url', 'medium_url', 'optimized_url', 'small_url'];
